var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "5 2 71.36 74.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_941_62)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0778 18.9051H9.61011L14.6037 76.2266H38.0848L39.44 60.6709V60.6685L43.0778 18.9051ZM15.0064 4.31936L16.0762 16.5853H18.4077L17.2293 3.06012C17.178 2.45667 16.6685 1.99942 16.072 2H6.16258C5.52059 2 5 2.51958 5 3.15972C5 3.80045 5.5206 4.31943 6.16258 4.31943L15.0064 4.31936ZM41.1246 68.0931L40.4155 76.2257H69.5831C70.985 76.2257 72.2486 75.7445 73.1555 74.971C74.0128 74.24 74.5451 73.2433 74.5451 72.1588V68.093L41.1246 68.0931ZM73.9229 61.9566H41.6595L41.3268 65.7731H73.9234C74.629 65.7731 75.2611 65.5354 75.7093 65.1534C76.1085 64.8126 76.3559 64.3559 76.3559 63.8649C76.3559 63.3744 76.1079 62.9172 75.7093 62.5765C75.4425 62.3499 75.1122 62.1734 74.7393 62.0679L74.6821 62.0522C74.5648 62.0208 74.4504 61.998 74.1638 61.9695L73.9875 61.9579L73.9229 61.9566ZM54.1799 44.1403C52.0135 44.1403 49.9352 44.4327 47.9981 44.9739C46.186 45.4789 44.4905 46.2023 42.9526 47.104L41.86 59.6373H73.8485C73.5141 55.5314 71.4142 51.8297 68.1897 49.0775C64.6155 46.0277 59.6639 44.1403 54.1799 44.1403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_941_62",
    x: 0,
    y: 0,
    width: 101.356,
    height: 104.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_941_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_941_62",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/food-icon.ddb20224761e520d3ff49ed58c6dde2a.svg";
export { ForwardRef as ReactComponent };